<template>
  <NuxtLoadingIndicator color="linear-gradient(90deg, rgba(251,210,0,1) 0%, rgba(46,178,244,1) 65%)" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup>
const i18nHead = useLocaleHead({
  addSeoAttributes: {}
});
const linkHead = i18nHead.value.link ?? [];
const metaHead = i18nHead.value.meta ?? [];

const route = useRoute();

useHead({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs?.lang
  },
  link: linkHead,
  meta: [
    ...metaHead,
    {name: 'theme-color', content: '#FBD200'},
  ],
  title: 'Betobee',
  titleTemplate: '%s - Betobee',
  bodyAttrs: {
    class: computed(() => {
      return ['default'].includes(route.meta.layout) ? 'dark' : '';
    }),
  },
})
</script>